import React, { Children, lazy } from 'react';
interface LazySectionProps {
  children: React.ReactNode;
  className?: string;
  threshold?: number;
  delay?: number;
}
/**
 * Pass-through wrapper. Previously used framer-motion useInView with
 * opacity gating, which could leave huge sections permanently invisible
 * when the IntersectionObserver didn't fire as expected.
 *
 * Children are always rendered. The browser already lazy-loads images
 * and videos via loading="lazy" / preload="metadata".
 */
export function LazySection({
  children,
  className = ''
}: LazySectionProps) {
  return <div className={className} data-id="element-164">{children}</div>;
}